import Vue from 'vue'

const state = {
  specialOffer: null
}

const getters = {
  specialOffer (state) {
    return state.specialOffer
  }
}

const mutations = {
  getInfo (state) {
    Vue.axios.get('/info')
      .then(request => {
        if (request.data.data.attributes === null) {
          return
        }
        state.specialOffer = request.data.data.attributes.special_offer
      })
  }
}

const actions = {
  getInfo ({ commit }) {
    commit('getInfo')
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
